import service from '../service/fenqile'
import CONSTANT from '../constant/fenqile'
import _ from 'underscore'
export default {
    bindFenqileAccount ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.bindFenqileAccount(data).then(result => {
                resolve(result)
                commit(CONSTANT.FENQILE_BINDFENQILEACCOUNT_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.FENQILE_BINDFENQILEACCOUNT_ERROR, e)
            })
        })
    },
    fenqileLogin ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.fenqileLogin(data).then(result => {
                resolve(result)
                commit(CONSTANT.FENQILE_FENQILELOGIN_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.FENQILE_FENQILELOGIN_ERROR, e)
            })
        })
    },
    getFenqilePayUrl ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getFenqilePayUrl(data).then(result => {
                resolve(result)
                commit(CONSTANT.FENQILE_GETFENQILEPAYURL_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.FENQILE_GETFENQILEPAYURL_ERROR, e)
            })
        })
    },
    fenqilePayTrial ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.fenqilePayTrial(data).then(result => {
                resolve(result)
                commit(CONSTANT.FENQILE_FENQILEPAYTRIAL_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.FENQILE_FENQILEPAYTRIAL_ERROR, e)
            })
        })
    },
    getAppToken ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getAppToken(data).then(result => {
                resolve(result)
                commit(CONSTANT.FENQILE_GETAPPTOKEN_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.FENQILE_GETAPPTOKEN_ERROR, e)
            })
        })
    },
    /*yeoman-template-point-1*/
}